import { Button } from "front-commons/ds";
import styled from 'styled-components';

export const ButtonClose = styled(Button)``;